var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVisibilityOff24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.133,
    height: 11.348,
    viewBox: "0 0 13.133 11.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.57,5.389a2.987,2.987,0,0,1,2.986,2.986,2.9,2.9,0,0,1-.215,1.093l1.744,1.744a7.058,7.058,0,0,0,2.049-2.837A7.063,7.063,0,0,0,7.564,3.9a6.955,6.955,0,0,0-2.377.418L6.477,5.6A2.9,2.9,0,0,1,7.57,5.389ZM1.6,3.758,2.959,5.12l.275.275A7.05,7.05,0,0,0,1,8.375a7.06,7.06,0,0,0,9.186,3.978l.251.251,1.75,1.744.758-.758L2.356,3Zm3.3,3.3.926.926a1.685,1.685,0,0,0-.048.388A1.789,1.789,0,0,0,7.57,10.167a1.685,1.685,0,0,0,.388-.048l.926.926A2.967,2.967,0,0,1,4.9,7.061ZM7.474,6.6,9.355,8.477l.012-.1A1.789,1.789,0,0,0,7.576,6.589Z",
    transform: "translate(-1 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityOff24Px);
export default __webpack_public_path__ + "static/media/ic_visibility_off_24px.8c77dfa0.svg";
export { ForwardRef as ReactComponent };